import React from "react";
import T from "prop-types";
import { Modal, Close, Header, Body } from "MODULES/shared/components/Modal";
import Form from "./Form";

function CreateInventoryShipmentModal({ editing, close, inventory }) {
  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Create Inventory Shipment</h4>
      </Header>
      <Body>
        <Form close={close} inventory={inventory.toJS()} enableReinitialize />
      </Body>
    </Modal>
  );
}

CreateInventoryShipmentModal.propTypes = {
  close: T.func.isRequired,
  editing: T.bool.isRequired,
  inventory: T.shape()
};

export default CreateInventoryShipmentModal;



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/CreateInventoryShipment/CreateInventoryShipmentModal.jsx